module.exports = __webpack_public_path__ + "static/img/logo-notificaciones.ea19077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-notificaciones.png
// module id = bro/
// module chunks = 9